import { appendData } from "Common/api/apiMiddleware.utils";
import axios from "axios";
import forEach from "lodash/forEach";
export default {
    getFolders: (documentId) => axios.post("/Documents/GetUserContentFolders", { documentId }),
    getFiles: (folderId) => axios.post("/Documents/GetUserContents", { folderId }),
    deleteFolder: (folderId) => axios.post("/Documents/DeleteUserContentFolder", { folderId }),
    deleteFile: (fileId) => axios.post("/Documents/DeleteUserContent", { fileId }),
    saveFolder: (folder, files) => {
        const formData = new FormData();
        appendData(formData, folder, "folderViewModel");
        forEach(files, file => {
            formData.append("files[]", file, file.name);
        });
        return axios.post("/Documents/SaveUserContentFolder", formData);
    },
    downloadFile: (fileId) => axios.get(`/Documents/DownloadUserContentFile?id=${fileId}`, {
        responseType: "blob"
    }),
    onBuildFileUrl: (file) => `${process.env.REACT_API_BASE_URL}/Documents/ViewUserContentFile?id=${file.Id}`
};
